import React from 'react';
import { useInfoValue, JobTitle } from '../Contexts/InfoContext';
import { LosAngelesAddress } from '../Common/LosAngelesAddress';
import { CompanyURL } from '../Common/CompanyURL';

export const TemplateThree = () => {
	const { data } = useInfoValue();

	const telOfficeNumber = data.officePhone ? data.officePhone : '310.376.7800';
	const telMobileNumber = data.mobilePhone ? data.mobilePhone : null;

	return (
		<table
			id="signatureMarkup"
			cellPadding="0"
			cellSpacing="0"
			style={{
				verticalSpacing: '-webkit-baseline-middle',
				fontSize: 'medium',
				fontFamily: 'Helvetica, Arial, sans-serif'
			}}
		>
			<tbody>
				<tr>
					<td style={{ verticalAlign: 'top', display: 'block' }}>
						<table
							cellPadding="0"
							cellSpacing="0"
							style={{
								verticalAlign: '-webkit-baseline-middle',
								fontSize: 'medium',
								padding: '0',
								margin: '0'
							}}
						>
							<tbody>
								<tr>
									<td style={{ textAlign: 'left' }}>
										<a href="https://thisisemergent.com/" target="_blank" rel="noopener noreferrer">
											<img
												width="150"
												src="https://tgscdn.sfo2.cdn.digitaloceanspaces.com/email-signatures/logo-emergent.png"
												alt="Emergent Media"
												role="presentation"
												style={{ maxWidth: '150px', display: 'block' }}
											/>
										</a>
									</td>
								</tr>
							</tbody>
						</table>

						<table cellPadding="0" cellSpacing="0">
							<tbody>
								<tr>
									<td style={{ display: 'block', clear: 'both' }} height="20px">
										<div>&nbsp;</div>
									</td>
								</tr>
							</tbody>
						</table>

						<table cellPadding="0" cellSpacing="0" style={{ padding: '0 0 0 5px' }}>
							<tbody>
								<tr>
									<td>
										<span
											color="#181818"
											style={{
												color: '#181818',
												textTransform: 'Capitalize',
												fontSize: '16px',
												textAlign: 'left',
												font: 'bold',
												fontWeight: '700',
												fontFamily: 'Helvetica, Arial, sans-serif',
												paddingTop: '0',
												paddingBottom: '0'
											}}
										>
											<span>{data.firstName ? data.firstName : 'Michael'}</span>
											<span>&nbsp;</span>
											<span>{data.lastName ? data.lastName : 'Scott'}</span>
										</span>
									</td>
								</tr>

								<tr>
									<td>
										<span
											color="#808080"
											style={{
												fontFamily: 'Helvetica, Arial, sans-serif',
												fontSize: '12px',
												color: '#808080',
												paddingTop: '7px',
												display: 'block'
											}}
										>
											{' '}
											{data.jobTitle ? data.jobTitle : 'Regional Manager'}
										</span>
									</td>
								</tr>
							</tbody>
						</table>
					</td>

					<td align="center" valign="top">
						<table border="0" cellPadding="0" cellSpacing="0">
							<tbody>
								<tr>
									<td valign="top">
										&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									</td>
								</tr>
							</tbody>
						</table>
					</td>

					<td style={{ padding: '0px', verticalAlign: 'middle' }}>
						<table
							cellPadding="0"
							cellSpacing="0"
							style={{
								verticalAlign: '-webkit-baseline-middle',
								fontSize: 'medium',
								display: 'inline-block'
							}}
						>
							<tbody>
								<tr
									style={{
										textAlign: 'center',
										display: 'block',
										marginBottom: '15px',
										marginTop: '5px'
									}}
								>
									<td style={{ padding: '0 5px 0 0' }}>
										<a
											href="https://goldenstate.is/"
											target="_blank"
											rel="noopener noreferrer"
											style={{
												display: 'inline-block',
												padding: '0px',
												verticalAlign: 'top',
												lineHeight: '10px'
											}}
										>
											<img
												height="20"
												src="https://tgscdn.sfo2.cdn.digitaloceanspaces.com/email-signatures/social-icon-gs-black.png"
												alt="Golden State Company"
												style={{ maxWidth: '135px', display: 'block' }}
											/>
										</a>
									</td>

									<td style={{ padding: '0 5px' }}>
										<a
											href="https://shltr.is/"
											target="_blank"
											rel="noopener noreferrer"
											style={{
												display: 'inline-block',
												padding: '0px',
												verticalAlign: 'top',
												lineHeight: '10px'
											}}
										>
											<img
												height="20"
												src="https://tgscdn.sfo2.cdn.digitaloceanspaces.com/email-signatures/social-icon-shltr-black.png"
												alt="Shltr"
												style={{ maxWidth: '135px', display: 'block' }}
											/>
										</a>
									</td>

									<td style={{ padding: '0 5px' }}>
										<a
											href="https://driftward.com/"
											target="_blank"
											rel="noopener noreferrer"
											style={{
												display: 'inline-block',
												padding: '0px',
												verticalAlign: 'top',
												lineHeight: '10px'
											}}
										>
											<img
												height="20"
												src="https://tgscdn.sfo2.cdn.digitaloceanspaces.com/email-signatures/social-icon-dw-black.png"
												alt="Driftward"
												style={{ maxWidth: '135px', display: 'block' }}
											/>
										</a>
									</td>

									<td style={{ padding: '0 5px' }}>
										<a
											href="https://findyourparadise.co/"
											target="_blank"
											rel="noopener noreferrer"
											style={{
												display: 'inline-block',
												padding: '0px',
												verticalAlign: 'top',
												lineHeight: '10px'
											}}
										>
											<img
												height="20"
												src="https://tgscdn.sfo2.cdn.digitaloceanspaces.com/email-signatures/social-icon-pr-black.png"
												alt="Paradise"
												style={{ maxWidth: '135px', display: 'block' }}
											/>
										</a>
									</td>
								</tr>
							</tbody>
						</table>

						<table cellPadding="0" cellSpacing="0" style={{ fontSize: 'medium', marginLeft: '7px' }}>
							<tbody>
								<tr style={{ verticalAlign: 'middle' }}>
									<td style={{ padding: '12px 0 0', minWidth: '20px' }}>
										<table cellPadding="0" cellSpacing="0" style={{ fontSize: 'medium' }}>
											<tbody>
												<tr>
													<td
														style={{
															fontSize: '11px',
															color: '#808080',
															lineHeight: '15px',
															textDecoration: 'none!important',
															textDecoration: 'none',
															marginRight: '5px',
															display: 'block'
														}}
													>
														<span>o.&nbsp;</span>
													</td>

													<td
														style={{
															fontSize: '11px',
															color: '#808080',
															lineHeight: '15px',
															textDecoration: 'none!important',
															textDecoration: 'none',
															minWidth: '70px'
														}}
													>
														<span>
															<a
																style={{
																	textDecoration: 'none',
																	color: '#808080'
																}}
																href={`tel:${telOfficeNumber}`}
															>
																{telOfficeNumber}
															</a>
														</span>
													</td>
												</tr>
											</tbody>
										</table>
									</td>
									<td style={{ padding: '12px 0 0', minWidth: '20px' }}>
										{data.mobilePhone ? (
											<table cellPadding="0" cellSpacing="0" style={{ fontSize: 'medium' }}>
												<tbody>
													<tr>
														<td
															style={{
																fontSize: '11px',
																color: '#808080',
																lineHeight: '15px',
																textDecoration: 'none',
																marginRight: '5px',
																marginLeft: '10px',
																display: 'block'
															}}
														>
															<span>&nbsp;&nbsp;m.&nbsp;</span>
														</td>

														<td
															style={{
																fontSize: '11px',
																color: '#808080',
																lineHeight: '15px',
																textDecoration: 'none',
																minWidth: '70px'
															}}
														>
															<span>
																<a
																	style={{
																		textDecoration: 'none',
																		color: '#808080'
																	}}
																	href={`tel:${telMobileNumber}`}
																>
																	{telMobileNumber}
																</a>
															</span>
														</td>
													</tr>
												</tbody>
											</table>
										) : null}
									</td>
								</tr>
							</tbody>
						</table>

						<table
							cellPadding="0"
							cellSpacing="0"
							style={{
								fontSize: 'medium',
								marginLeft: '7px',
								fontFamily: 'Helvetica, Arial, sans-serif'
							}}
						>
							<tbody>
								<CompanyURL url={'thisisemergent.com'} />
								<LosAngelesAddress />
							</tbody>
						</table>
					</td>
				</tr>
			</tbody>
		</table>
	);
};
